<script setup lang="ts">
import type { GatIconProps } from '../../gat-icon'
import { GatIcon } from '../../gat-icon'
import { GatLink, type GatLinkProps } from '../../gat-link'

export interface DataTableCellPopoverContentHeaderProps {
  title: string
  href?: GatLinkProps['href']
  icon?: GatIconProps['icon']
}

const props = defineProps<DataTableCellPopoverContentHeaderProps>()
</script>
<template>
  <div class="border-b">
    <div class="flex items-center gap-1 p-2 text-xs font-medium">
      <gat-icon v-if="props.icon" :icon="props.icon" class="size-3.5 shrink-0" />
      <div>
        <gat-link v-if="props.href" :href="props.href" :text="props.title" type="external-link" />
        <div v-else>{{ props.title }}</div>
      </div>
    </div>
  </div>
</template>
